module.exports = __webpack_public_path__ + "img/side_L.bb2f92dc.svg";